import Component from '@bythepixel/component-loader';

export default class MenuBackground extends Component {
  static selector = '[comp-menu-background]'

  constructor(...args) {
    super(...args);
    this.slides = this.$container.querySelectorAll('[data-slide-index]');
    this.events();
  }

  events() {
    this.$subscribe('desktop-menu:activate-tab', ({ index }) => {
      if (typeof index !== 'number') return;
      this.slides.forEach(slide => {
        if (Number(slide.dataset.slideIndex) === Number(index)) {
          slide.classList.remove('opacity-0');
        } else {
          slide.classList.add('opacity-0');
        }
      });
    });
  }
}
